<template>
  <div class="difficult-question-tooltip">
    <div class="flex items-center font-bold text-sm">
      <aha-progress-circle
        class="mr-1 w-8 -mt-0.5"
        inner-circle-color="#FF4954"
        progress-bar-color="#33C173"
        :percent="slide.correctRate * 100"
        :radius="7"
        :ring-width="3"
        box-shadow="none"
        inner-box-shadow="none"
      />
      <span>Correct rate</span>
      <span class="ml-auto">{{ (slide.correctRate * 100).toFixed(1) + '%' }}</span>
    </div>
    <div class="border-b border-secondary-60 my-2"></div>
    <p class="flex items-center mb-2">
      <aha-icon
        class="text-green-50 mt-1"
        name="correct"
        viewBox="0 0 24 24"
        width="16"
        height="16"
      />
      Correct
      <span class="ml-auto">
        {{ slide.correctAnswerCount | formatNumber }}/{{ slide.totalAnswerCount | formatNumber }}
        <aha-icon
          class="text-base-0 -mt-0.5"
          name="user-solid"
          width="12"
          height="12"
          viewBox="0 0 16 17"
        />
      </span>
    </p>
    <p class="flex items-center">
      <aha-icon
        class="text-red-50 mt-1"
        name="incorrect"
        viewBox="0 0 24 24"
        width="16"
        height="16"
      />
      Incorrect
      <span class="ml-auto flex items-center">
        {{ (slide.totalAnswerCount - slide.correctAnswerCount) | formatNumber }}/{{ slide.totalAnswerCount | formatNumber }}
        <aha-icon
          class="text-base-0 ml-1 -mt-0.5"
          name="user-solid"
          width="12"
          height="12"
          viewBox="0 0 16 17"
        />
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    slide: {
      type: Object,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.difficult-question-tooltip {
  @apply bg-secondary-100 text-base-0 rounded p-3 text-sm w-52;
  pointer-events: none;
}
</style>
